/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_AriaInputs */

const en_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export subtitle file`)
};

const fr_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter un fichier de sous-titres`)
};

const de_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei exportieren`)
};

const it_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta file sottotitoli`)
};

const ru_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт файла субтитров`)
};

const es_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar archivo de subtítulos`)
};

const zh_cn2_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出字幕文件`)
};

const ja_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルをエクスポート`)
};

const hi_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल निर्यात करें`)
};

const pt_pt2_file_export_subtitle_file_aria = /** @type {(inputs: File_Export_Subtitle_File_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar arquivo de legenda`)
};

/**
* | output |
* | --- |
* | "Export subtitle file" |
*
* @param {File_Export_Subtitle_File_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_aria = /** @type {((inputs?: File_Export_Subtitle_File_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_subtitle_file_aria(inputs)
	if (locale === "de") return de_file_export_subtitle_file_aria(inputs)
	if (locale === "it") return it_file_export_subtitle_file_aria(inputs)
	if (locale === "ru") return ru_file_export_subtitle_file_aria(inputs)
	if (locale === "es") return es_file_export_subtitle_file_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_subtitle_file_aria(inputs)
	if (locale === "ja") return ja_file_export_subtitle_file_aria(inputs)
	if (locale === "hi") return hi_file_export_subtitle_file_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_subtitle_file_aria(inputs)
	return en_file_export_subtitle_file_aria(inputs)
});